import { TimezoneDetails } from './store/timeZoneSlice';

/**
 * Common Constants for the application
 */
export const commonConstant = {
  EM_CLIENT_ID: 'SD1XIzWdpO6SfbSfkJhhhpQU1JuSR5q3',
  CURRENT_FULFILLER_SETTING: 'currentFulfillerSetting',
  DEFAULT_STATUS_COLOR: '#35AD96',
  FULFILLER_TIMEZONE_PREFERENCE: 'fulfillerTimezonePreference',
};

/**
 * Enum of Environment Format
 */
export enum Environment {
  PRODUCTION = 'production',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
}

/**
 * Names of columns for list view
 */
export const COLUMN_DEFINITIONS = {
  NAME: 'name',
  VERSION_ID: 'latest version',
  LATEST_UPDATE: 'last updated',
  DESCRIPTION: 'description',
  TAGS: 'tags',
};
export const COLUMN_HEADERS = {
  NAME: 'Name',
  VERSION_ID: 'Latest version',
  LATEST_UPDATE: 'Last updated',
  DESCRIPTION: 'Description',
  TAGS: 'Tags',
};
/**
 * Data types for attributes
 */
export const DATA_TYPES = [
  { value: 'string', label: 'String' },
  { value: 'integer', label: 'Integer' },
  { value: 'number', label: 'Number' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'array', label: 'Array' },
  { value: 'object', label: 'Object' },
];

/**
 * Status/State options for stages
 */
export const STATUS_OPTIONS = [
  { value: 'created', label: 'Created' },
  { value: 'readyForProcessing', label: 'Ready For Processing' },
  { value: 'inProgress', label: 'In Progress' },
  { value: 'onHold', label: 'On Hold' },
  { value: 'completed', label: 'Completed' },
  { value: 'terminated', label: 'Terminated' },
];

/**
 * Cardinality options for relationships
 */
export const CARDINALITY_OPTIONS = [
  { value: 'one-to-one', label: 'One to One' },
  { value: 'one-to-many', label: 'One to Many' },
  { value: 'many-to-one', label: 'Many to One' },
  { value: 'many-to-many', label: 'Many to Many' },
];

/**
 * Enum for Create Entity Type Page tabs
 */
export enum CreateEntityTypeTab {
  GENERAL = 'General',
  ATTRIBUTES = 'Attributes',
  STAGES = 'Stages',
  RELATIONSHIPS = 'Relationships',
}

// Re-export SelectOption from models for backward compatibility
export type { SelectOption } from './models/EditableList';

/**
 * Common inline style constants for form components
 */
export const FIELD_STYLE = { marginBottom: 0 } as const;
export const BUTTON_STYLE = { height: 48 } as const;
export const BUTTON_GROUP_STYLE = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
} as const;

export const externalEntityTypes = [
  { label: 'Order', value: '9P0NW4XUIA' },
  { label: 'OrderedItem', value: '9ADCIG4VNP' },
];

export const AVAILABLE_TIMEZONES: TimezoneDetails[] = [
  { label: 'UTC (+00:00)', abbreviation: 'UTC', value: 'UTC' },
  {
    label: 'Eastern Time (UTC-05:00)',
    abbreviation: 'EST',
    value: 'America/New_York',
  },
  {
    label: 'Central Time (UTC-06:00)',
    abbreviation: 'CST',
    value: 'America/Chicago',
  },
  {
    label: 'Mountain Time (UTC-07:00)',
    abbreviation: 'MST',
    value: 'America/Denver',
  },
  {
    label: 'Pacific Time (UTC-08:00)',
    abbreviation: 'PST',
    value: 'America/Los_Angeles',
  },
  {
    label: 'Greenwich Mean Time (UTC+00:00)',
    abbreviation: 'GMT',
    value: 'Europe/London',
  },
  {
    label: 'Central European Time (UTC+01:00)',
    abbreviation: 'CET',
    value: 'Europe/Berlin',
  },
  {
    label: 'Eastern European Time (UTC+02:00)',
    abbreviation: 'EET',
    value: 'Europe/Athens',
  },
  {
    label: 'India Standard Time (UTC+05:30)',
    abbreviation: 'IST',
    value: 'Asia/Calcutta',
  },
  {
    label: 'China Standard Time (UTC+08:00)',
    abbreviation: 'CST',
    value: 'Asia/Shanghai',
  },
  {
    label: 'Japan Standard Time (UTC+09:00)',
    abbreviation: 'JST',
    value: 'Asia/Tokyo',
  },
  {
    label: 'Korea Standard Time (UTC+09:00)',
    abbreviation: 'KST',
    value: 'Asia/Seoul',
  },
  {
    label: 'Australian Eastern Time (UTC+10:00)',
    abbreviation: 'AEST',
    value: 'Australia/Sydney',
  },
  {
    label: 'Australian Central Time (UTC+09:30)',
    abbreviation: 'ACST',
    value: 'Australia/Adelaide',
  },
  {
    label: 'Australian Western Time (UTC+08:00)',
    abbreviation: 'AWST',
    value: 'Australia/Perth',
  },
  { label: 'Dubai Time (UTC+04:00)', abbreviation: 'GST', value: 'Asia/Dubai' },
  {
    label: 'Moscow Time (UTC+03:00)',
    abbreviation: 'MSK',
    value: 'Europe/Moscow',
  },
  {
    label: 'Singapore Time (UTC+08:00)',
    abbreviation: 'SGT',
    value: 'Asia/Singapore',
  },
  {
    label: 'Hong Kong Time (UTC+08:00)',
    abbreviation: 'HKT',
    value: 'Asia/Hong_Kong',
  },
];

export const DEFAULT_TIMEZONE: TimezoneDetails = AVAILABLE_TIMEZONES[0];
